import events from '../events';
import '../events/resize';
import getWindowSize from '../utils/window-size';

const element = document.body;
const pseudo = '::before';

let current = null;
let winWidth = getWindowSize().width;

const medias = getMedias();
const breaks = getBreaks();

const operators = {
	'<': isLessThan,
	'>': isGreaterThan,
};

events.on('resize', onResize);

function getMedias() {
	if (window.getComputedStyle && (window.getComputedStyle(element, pseudo).content !== '')) {
		let data = window.getComputedStyle(element, pseudo).content;
		//data = JSON.parse(removeQuotes(data)); // funny hack goes wrong
		data = {phone: '320px', tablet: '768px', desktop: '1024px'}; //TODO fixme (not)
		Object.keys(data).map(k => data[k] = parseInt(data[k], 10));
		return data;
	} else {
		return {};
	}
}

function getBreaks() {
	return Object.values(medias).sort((a, b) => b - a);
}

function onResize(size) {
	winWidth = size.width;
	triggerMedia(winWidth);
}

function triggerMedia(size) {
	let media = getMedia(size);
	if (current !== media) {
		current = media;
		events.emit('break', media);
		events.emit(`break::${media}`);
	}
}

function getMedia(size) {
	let val = null;
	for (val of breaks) {
		if (size.width > val) {
			break;
		}
	}
	return Object.keys(medias).filter(k => medias[k] === val)[0];
}

// https://css-tricks.com/making-sass-talk-to-javascript-with-json/
function removeQuotes(str) {
	if (typeof str === 'string' || str instanceof String) {
		return str.replace(/^['"]+|\s+|\\|(;\s?})+|['"]$/g, '');
	}
}

export function isLessThan(label) {
	return winWidth <= medias[label];
}

export function isGreaterThan(label) {
	return winWidth >= medias[label];
}

export function isBetween(label1, label2) {
	return isGreaterThan(label1) && isLessThan(label2);
}

export function matchMedia(str) {
	let reg = /^([<>])(\w+)/;
	let [foo, operator, label] = []; // eslint-disable-line  no-unused-vars
	try {
		[foo, operator, label] = str.match(reg);
	} catch (err) {
		// throw new Error('Invalid label');
	}
	let f = operators[operator];
	return f(label);
}

export default {
	get current() {
		return current;
	}
};
